import React from 'react';
import { Phone, PhoneCall, MessageSquare, Voicemail, Calendar, Video as LucideIcon } from 'lucide-react';
import KPICard from './KPICard';

interface MetricConfig {
  value: number;
  label: string;
  icon: LucideIcon;
  suffix?: string;
}

interface TodayHighlightsProps {
  metrics: MetricConfig[];
}

const TodayHighlights: React.FC<TodayHighlightsProps> = ({ metrics }) => {
  const gridCols = metrics.length <= 5
    ? 'lg:grid-cols-5'
    : 'lg:grid-cols-6';

  return (
    <div className="space-y-4">
      <div className="flex items-center space-x-3">
        <div className="w-10 h-10 bg-gradient-to-br from-[#1875FF] to-[#05E0D1] rounded-xl flex items-center justify-center shadow-lg">
          <Calendar className="text-white" size={22} />
        </div>
        <h2 className="text-2xl font-extrabold text-gray-900 tracking-tight font-display">Today's Highlights</h2>
      </div>
      <div className={`grid grid-cols-1 md:grid-cols-3 ${gridCols} gap-4`}>
        {metrics.map((metric, index) => (
          <KPICard
            key={index}
            title={metric.label}
            value={metric.value}
            icon={metric.icon}
            suffix={metric.suffix}
          />
        ))}
      </div>
    </div>
  );
};

export default TodayHighlights;
